@if(!!label){
    <label [for]="datePicker" class="text-input-label">{{label}}</label>
}
<mat-form-field appearance="outline" [ngClass]="fieldClass">
    <input matInput [id]="id" [matDatepicker]="datePicker" [disabled]="disabled" [(ngModel)]="value" [min]="minDate"
        [max]="maxDate" (focus)="datePicker.open()" class="lo_sensitive" (dateInput)="addEvent('input', $event)"
        (dateChange)="dateChanged($event)" [placeholder]="placeholder" [errorStateMatcher]="matcher" (blur)="markAsTouched()"/>
    <mat-datepicker-toggle matSuffix [for]="datePicker" />
    <mat-datepicker #datePicker [startAt]="startAt" [startView]="startView" />
    <mat-error *ngIf="requiredError">Required</mat-error>
    <mat-error *ngIf="minError">{{minErrorTxt}}</mat-error>
    <mat-error *ngIf="maxError">{{maxErrorTxt}} </mat-error>
</mat-form-field>